module.exports = __webpack_public_path__ + "static/media/about-history.e5163262.png";